<div class="announcement-banner" *ngIf="showBanner">
  <div class="announcement-content">
    <span class="announcement-icon">📢</span>
    <div class="announcement-text">
      <strong>Зміна тарифів з 1 травня 2025</strong>
      <span class="announcement-prices">
        <span>Стандарт <b>$10</b></span>
        <span>Telegram <b>$10</b></span>
        <span>Telegram Bot <b>$2</b></span>
        <span>Viber <b>$20</b></span>
        <span>Instagram <b>$3</b></span>
        <span>Prom <b>$3</b></span>
        <span>RIA <b>$10</b></span>
        <span class="no-change">OLX — без змін</span>
      </span>
      <a href="https://t.me/jecrm_manager" target="_blank" class="announcement-contact">Питання → &#64;jecrm_manager</a>
    </div>
  </div>
  <button class="announcement-close" (click)="closeBanner()" aria-label="Закрити">✕</button>
</div>

<header class="header">
  <div class="header-left" [ngClass]="{ 'mobile-header' : baseService.isMobile }">
    <div class="menu-btn">
      <button mat-icon-button [matMenuTriggerFor]="leftMenu">
        <app-icon>menu</app-icon>
      </button>
      <mat-menu #leftMenu="matMenu">
        <button *ngFor="let item of headerLinks" [routerLink]="item.link" mat-menu-item>
          <app-icon>{{ item.icon }}</app-icon>
          <span>{{ item.title | translate }}</span>
        </button>
        <button mat-menu-item (click)="baseService.openSite(linkRegister, true)">
          <app-icon>how_to_reg</app-icon>
          <span>{{ 'registration' | translate }}</span>
        </button>
        <button mat-menu-item (click)="baseService.openSite(linkLogin, true)">
          <app-icon>login</app-icon>
          <span>{{ 'login' | translate }}</span>
        </button>
      </mat-menu>
    </div>
    <img title="JECRM" src="assets/img/jecrm.png" alt="JECRM-Logo" class="logo" />
    <ng-container *ngIf="baseService.isMobile">
      <button mat-icon-button [matMenuTriggerFor]="menu">
        <app-icon [svgIcon]="currentLanguage"></app-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button (click)="onChangeLanguage(item.value)" mat-menu-item *ngFor="let item of languages">
          <app-icon class="icon" [svgIcon]="item.icon"></app-icon>
          <span>{{ item.name }}</span>
        </button>
      </mat-menu>
    </ng-container>
    <nav *ngIf="!baseService.isMobile" class="nav crm-scroll">
      <a
        [title]="item.title | translate"
        *ngFor="let item of headerLinks"
        [routerLink]="item.link"
      >
        {{ item.title | translate }}
      </a>
    </nav>
  </div>

  <div class="header-right" *ngIf="!baseService.isMobile">
    <button mat-icon-button [matMenuTriggerFor]="menu">
      <app-icon [svgIcon]="currentLanguage"></app-icon>
    </button>
    <mat-menu #menu="matMenu">
      <button (click)="onChangeLanguage(item.value)" mat-menu-item *ngFor="let item of languages">
        <app-icon class="icon" [svgIcon]="item.icon"></app-icon>
        <span>{{ item.name }}</span>
      </button>
    </mat-menu>

    <a [title]="'login' | translate" [href]="baseService.modifyLink(linkLogin)" class="login">
      <app-button [title]="'login' | translate" [isOutline]="true"></app-button>
    </a>
    <a [title]="'registration' | translate" [href]="baseService.modifyLink(linkRegister)">
      <app-button [title]="'registration' | translate"></app-button>
    </a>
  </div>
</header>
